import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'
import get from 'lodash/get'

import { projectApi } from '@atheneum/api'

import Segment from './Segment'
import InfoBox from '@components/InfoBox'
import InfoIcon from '@components/Icon/Info'
import EplModel from '@models/EPL.model'

class ClientView extends Component {
  static propTypes = {
    segments: PropTypes.arrayOf(PropTypes.object),
    projectStore: PropTypes.object,
    segmentStore: PropTypes.object,
    staticData: PropTypes.object,
    growlStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    const segments = get(props.projectStore, 'segmentStore.segments', [])
    const segmentMap = {}
    segments.forEach(segment => {
      segmentMap[segment.id] = {
        loading: true,
        epls: []
      }
    })

    extendObservable(this, {
      segments: segmentMap
    })
    this.getEpls(segments).then(() => {
      this.loadPageCounts()
    })
  }

  componentDidMount () {
    // fo autofocus issue caused by drag n drop lib used on this view
    document.getElementById('expert-quick-search-input').focus()
  }

  getEpls = segments => {
    const promises = segments.map(segment => {
      this.segments[segment.id].loading = true
      return projectApi
        .getSegmentEpls(segment.id)
        .then(segmentEpls => {
          const { staticData } = this.props
          const epls = segmentEpls.map(epl => new EplModel(epl, staticData))
          this.segments[segment.id].epls.replace(epls)
          this.segments[segment.id].loading = false
        })
        .catch(error => {
          this.segments[segment.id].loading = false
          const message = `Error: ${error.message ||
            'Unkown error'}. Please try refreshing the page`
          this.props.growlStore.addNotification({
            title: 'Error while loading EPLs!',
            message,
            type: 'error',
            autoClose: true
          })
        })
    })
    return Promise.all(promises)
  }

  loadPageCounts () {
    const projectStore = this.props.projectStore
    const projectId = projectStore.project.id

    return projectStore
      .getPageCountForProject(projectId)
      .then(() => {
        const eplIds = Object.values(this.segments).reduce((ids, seg) => {
          const segmentEplIds = seg.epls.map(e => e.id)
          return ids.concat(segmentEplIds)
        }, [])
        return projectStore.getPageCountForEpls(eplIds)
      })
      .catch(error => {
        const message = `Error: ${error.message ||
          'Unkown error'}. Please try refreshing the page`
        this.props.growlStore.showError({
          title: 'Error while loading page view counters!',
          message
        })
      })
  }

  render () {
    const projectStore = this.props.projectStore
    const { segments } = this.props.segmentStore
    const projectName = projectStore.project.projectName

    if (!segments || segments.length < 1) return null
    const segmentList = segments.map(segment => {
      const { loading, epls } = this.segments[segment.id]
      return (
        <Segment
          key={segment.id}
          segment={segment}
          loading={loading || false}
          epls={epls}
          loggedEvents={projectStore.loggedEvents}
        />
      )
    })

    const project = projectStore.loggedEvents.project
    const count = project ? project.count : 0

    const projectCount = <div>Project views: {count}</div>

    return (
      <DocumentTitle title={`${projectName} - client view | Atheneum Partners`}>
        <div className='details-wrapper animate-intro'>
          <InfoBox theme='blue' icon={<InfoIcon />}>
            <span>Drag and Drop EPLs to reorder within the same segment.</span>
          </InfoBox>
          {projectCount}
          <div className='story'>{segmentList}</div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject(
  'projectStore',
  'staticData',
  'growlStore',
  'segmentStore'
)(observer(ClientView))
